import { createActions } from 'redux-actions';
import { request } from '../../services';
import Schemas from 'schemas';
import { normalize } from 'normalizr';

const {
  divisionListRequest,
  divisionListSuccess,
  divisionListFailure,
} = createActions({
  DIVISION_LIST_SUCCESS: json => json.divisions,
}, 'DIVISION_LIST_REQUEST', 'DIVISION_LIST_FAILURE');

export function requestDivisionList() {
  return (dispatch) => {
    dispatch(divisionListRequest());
    return request('divisions')
      .then(({ json }) => {
        dispatch(divisionListSuccess(json));
      },
      (error) => {
        dispatch(divisionListFailure(error));
      });
  };
}


const {
  regionListRequest,
  regionListSuccess,
  regionListFailure,
} = createActions({
  REGION_LIST_SUCCESS: json => json.regions,
}, 'REGION_LIST_REQUEST', 'REGION_LIST_FAILURE');

export function requestRegionList(divisionId = null) {
  let queryString = '';
  if (divisionId) queryString = `?from_division=${divisionId}`;
  return (dispatch) => {
    dispatch(regionListRequest());
    return request(`regions${queryString}`)
      .then(({ json }) => {
        dispatch(regionListSuccess(json));
      },
      (error) => {
        dispatch(regionListFailure(error));
      });
  };
}


const {
  marketListRequest,
  marketListSuccess,
  marketListFailure,
} = createActions({
  MARKET_LIST_SUCCESS: json => json.markets,
}, 'MARKET_LIST_REQUEST', 'MARKET_LIST_FAILURE');

export function requestMarketList(regionId = null) {
  let queryString = '';
  if (regionId) queryString = `?from_region=${regionId}`;
  return (dispatch) => {
    dispatch(marketListRequest());
    return request(`markets${queryString}`)
      .then(({ json }) => {
        dispatch(marketListSuccess(json));
      },
      (error) => {
        dispatch(marketListFailure(error));
      });
  };
}


const {
  pricePatchListRequest,
  pricePatchListSuccess,
  pricePatchListFailure,
} = createActions({
  PRICE_PATCH_LIST_SUCCESS: json => normalize(json, { price_patches: Schemas.PRICE_PATCH_ARRAY }),
}, 'PRICE_PATCH_LIST_REQUEST', 'PRICE_PATCH_LIST_FAILURE');

export function requestPricePatchesList() {
  return (dispatch) => {
    dispatch(pricePatchListRequest());
    return request('price_patches')
      .then(({ json }) => {
        dispatch(pricePatchListSuccess(json));
      },
      (error) => {
        dispatch(pricePatchListFailure(error));
      });
  };
}

const {
  pricePatchLineItemListRequest,
  pricePatchLineItemListSuccess,
  pricePatchLineItemListFailure,
} = createActions({
  PRICE_PATCH_LINE_ITEM_LIST_SUCCESS: json => ({
    lineItems: json.line_items,
  }),
}, 'PRICE_PATCH_LINE_ITEM_LIST_REQUEST', 'PRICE_PATCH_LINE_ITEM_LIST_FAILURE');

export function requestPricePatchLineItemList(phaseId) {
  return (dispatch) => {
    dispatch(pricePatchLineItemListRequest());
    return request(`price_patch_line_items?phase_id=${phaseId}`)
      .then(({ json }) => dispatch(pricePatchLineItemListSuccess(json)),
      error => dispatch(pricePatchLineItemListFailure(error)));
  };
}

const {
  payRateLineItemListRequest,
  payRateLineItemListSuccess,
  payRateLineItemListFailure,
} = createActions({
  PAY_RATE_LINE_ITEM_LIST_SUCCESS: (json, referenceId) => ({
    lineItems: json.line_items,
    referenceId,
  }),
}, 'PAY_RATE_LINE_ITEM_LIST_REQUEST', 'PAY_RATE_LINE_ITEM_LIST_FAILURE');

export function requestPayRateLineItemList(contractorType, contractorId, referenceId) {
  return (dispatch) => {
    dispatch(payRateLineItemListRequest());
    return request(`pay_rate_line_items?contractor_type=${contractorType}&contractor_id=${contractorId}&labor_sheet_id=${referenceId}`)
      .then(({ json }) => dispatch(payRateLineItemListSuccess(json, referenceId)),
      error => dispatch(payRateLineItemListFailure(error)));
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/dropdown_lists.js